function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#DOGE_svg__clip0_1_41)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 15,
  cy: 14.722,
  rx: 15,
  ry: 14.167,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.361 9.883h-2.143v4.228h3.369v1.768h-3.37v4.223h2.247c.58 0 4.741.069 4.736-4.912-.005-4.98-4.038-5.307-4.839-5.307z",
  fill: "#C2A633"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 0C6.714 0 0 6.714 0 15s6.714 15 15 15 15-6.714 15-15S23.286 0 15 0zm.59 23.1h-5.434V15.88H8.242V14.11h1.914V6.89h4.663c1.104 0 8.408-.23 8.408 8.242 0 8.608-7.636 7.969-7.636 7.969z",
  fill: "#C2A633"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "DOGE_svg__clip0_1_41"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgDoge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "684541e24dfaf1033750ceedd6bb728e.svg";
export { SvgDoge as ReactComponent };